export enum ProductGender {
  unisex = 0,
  male = 1,
  female = 2,
  youth = 3,
  kids = 4,
  toddler = 5,
}
